var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCounterManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.54 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e{fill:#ef7843;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M26.76,49.98c-5.56,0-11.11,0-16.67,0C4.4,49.97,.02,45.61,.01,39.94c-.01-9.99-.01-19.99,0-29.98C.02,4.63,4.39,.09,9.74,.05,21.11-.02,32.48-.02,43.85,.06c5.21,.04,9.6,4.52,9.64,9.75,.06,10.17,.06,20.33,0,30.5-.03,5.35-4.46,9.62-9.93,9.67-5.6,.05-11.2,.01-16.8,.01Zm0-47.62c-5.64,0-11.28-.03-16.92,0-4.12,.02-7.48,3.39-7.49,7.48-.02,7.36-.02,14.73,0,22.09,.01,4.28,3.34,7.62,7.61,7.63,11.2,.02,22.39,.02,33.59,0,4.28,0,7.63-3.36,7.64-7.62,.02-7.23,.02-14.47,0-21.7-.01-4.62-3.28-7.88-7.89-7.89-5.51-.01-11.02,0-16.53,0Zm24.34,36.04c-2.55,2.77-5.61,3.55-9.09,3.53-10.55-.08-21.1-.03-31.64-.03-.6,0-1.2-.06-1.8-.13-2.43-.31-4.4-1.52-6.15-3.32-.46,5.79,2.78,9.33,8.37,9.33,10.59,0,21.18-.09,31.77,.04,5.34,.07,9.27-3.84,8.53-9.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M27.92,16.25c0,3.76,0,7.28,0,10.8,0,1.29-.01,2.58,0,3.87,.01,.86-.17,1.65-1.18,1.64-1.01,0-1.16-.81-1.16-1.66,.01-4.35,0-8.69,0-13.04,0-.47,0-.93,0-1.53h-4.17l5.47-5.46,5.37,5.37h-4.35Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounterManagement);
export default __webpack_public_path__ + "static/media/Counter Management.612eab735135a8c2647d3a651671f1ff.svg";
export { ForwardRef as ReactComponent };